// ServicesSection.jsx
import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import {
  FaCogs,
  FaUserGraduate,
  FaMicrochip,
  FaHandHoldingUsd,
  FaBullhorn,
  FaSearch,
} from 'react-icons/fa';

const ServicesSection = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, amount: 0.2 });

  const themeColor = "#1f5fa7";       // Govt blue
  const themeColorLight = "#eaf2fb";  // Light govt bg

  const services = [
    {
      id: 1,
      title: "General Services",
      description:
        "MSME development through regulatory frameworks, market research, financial resource identification, policy formulation and cluster development initiatives.",
      icon: FaCogs,
    },
    {
      id: 2,
      title: "Skill Development & Capacity Building",
      description:
        "Establishing Skill Development and EDP Centers, offering technical and vocational training to improve employability and enterprise growth.",
      icon: FaUserGraduate,
    },
    {
      id: 3,
      title: "Technology Transfer & Development",
      description:
        "Support in technology upgradation, R&D, quality control systems, renewable energy solutions and green technology adoption.",
      icon: FaMicrochip,
    },
    {
      id: 4,
      title: "Credit & Financial Services",
      description:
        "Preparation of DPR and DSR, facilitation of credit linkage, government subsidies, grants and affordable financial assistance.",
      icon: FaHandHoldingUsd,
    },
    {
      id: 5,
      title: "Marketing Promotion",
      description:
        "Market facilitation, global trade delegations, B2B meetings, export opportunities and government tender access.",
      icon: FaBullhorn,
    },
    {
      id: 6,
      title: "Research & Policy Advocacy",
      description:
        "Need assessment, gap analysis, MSME research, policy recommendations and development of national schemes.",
      icon: FaSearch,
    },
  ];

  const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 },
    },
  };

  return (
    <section
      ref={sectionRef}
      className="py-10 px-4 sm:px-6 lg:px-8 bg-[#f8fafc]"
    >
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <motion.div
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          variants={fadeInUp}
          className="text-center mb-14"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our <span style={{ color: themeColor }}>Services</span>
          </h2>
        
        </motion.div>

        {/* Services Grid */}
        <motion.div
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {services.map((service) => {
            const Icon = service.icon;
            return (
              <motion.div
                key={service.id}
                variants={fadeInUp}
                className="bg-white border border-gray-300 rounded-lg p-6 h-[200px] flex flex-col hover:shadow-md transition"
              >
                {/* Icon Bar */}
                <div className="flex items-center mb-4">
                  <div
                    className="w-12 h-12 flex items-center justify-center rounded-md mr-4"
                    style={{ backgroundColor: themeColorLight }}
                  >
                    <Icon className="w-6 h-6" style={{ color: themeColor }} />
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 leading-snug">
                    {service.title}
                  </h3>
                </div>

                {/* Divider */}
                <div
                  className="w-10 h-[2px] mb-4"
                  style={{ backgroundColor: themeColor }}
                ></div>

                {/* Description */}
                <p className="text-sm text-gray-700 leading-relaxed line-clamp-5">
                  {service.description}
                </p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default ServicesSection;
